import { Children, ReactNode, ReactNodeArray } from 'react';
import { TabsRole, URL_TAB_NAME_HASH_KEY } from './const';
import { TabElement, TabId } from './types';
import { addQueryParam, removeQueryParam } from '../../utils/url';

export const isTabList = (el: unknown): el is TabElement<TabsRole.TabList> => {
	// @ts-ignore
	return el?.type?.tabsRole === TabsRole.TabList;
};

export const isTab = (el: unknown): el is TabElement<TabsRole.Tab> => {
	// @ts-ignore
	return el?.type?.tabsRole === TabsRole.Tab;
};

export const isTabPanel = (el: unknown): el is TabElement<TabsRole.TabPanel> => {
	// @ts-ignore
	return el?.type?.tabsRole === TabsRole.TabPanel;
};

export const getTabList = (children: ReactNodeArray) => {
	return children.find((child) => isTabList(child)) as TabElement<TabsRole.TabList>;
};

export const getTabs = (tabList: TabElement<TabsRole.TabList>) => {
	const { children } = tabList.props;

	const tabs: TabElement<TabsRole.Tab>[] = [];

	Children.forEach(children, (child) => {
		if (isTab(child)) {
			tabs.push(child);
		}
	});

	return tabs;
};

export const getTabPanels = (children: ReactNode) => {
	const tabPanels: TabElement<TabsRole.TabPanel>[] = [];

	Children.forEach(children, (child) => {
		if (isTabPanel(child)) {
			tabPanels.push(child);
		}
	});

	return tabPanels;
};

export const getTabId = (id: TabId) => `tab-${id}`;
export const getTabPanelId = (id: TabId) => `tabpanel-${id}`;

export const addTabQueryParam = (url: string, tabId: string) => {
	return addQueryParam(url, URL_TAB_NAME_HASH_KEY, tabId);
};

export const removeTabQueryParam = (url: string) => {
	return removeQueryParam(url, URL_TAB_NAME_HASH_KEY);
};
